import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { useContent } from "../content/ContentContext";
import { Logo } from "./Ui";

export default function Footer() {
  const { content } = useContent();
  const { site } = content;
  return (
    <footer data-testid="site-footer" className="no-print border-t border-line bg-lavender/50">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-8">
            <Logo />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted">
              Business Intelligence and Business Analysis consultancy.
            </p>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.18em] text-accent">Contact</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a href={`mailto:${site.email}`} className="break-all text-ink hover:text-plum" data-testid="footer-email-link">
                  {site.email}
                </a>
              </li>
              <li className="pt-1">
                <a
                  href={site.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Stephanie Madojemu on LinkedIn (opens in a new tab)"
                  data-testid="footer-linkedin-link"
                  className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-line text-plum transition-colors duration-200 hover:bg-lavender/60 focus:outline-none focus-visible:bg-lavender/60 focus-visible:ring-2 focus-visible:ring-accent"
                >
                  <Linkedin aria-hidden="true" className="h-4 w-4" strokeWidth={2} />
                </a>
              </li>
              <li className="flex flex-wrap gap-x-4 pt-1">
                <Link to="/work" className="text-ink hover:text-plum" data-testid="footer-work-link">Selected work</Link>
                <Link to="/case-studies" className="text-ink hover:text-plum" data-testid="footer-cases-link">Case studies</Link>
                <Link to="/privacy" className="text-ink hover:text-plum" data-testid="footer-privacy-link">Privacy</Link>
              </li>
              <li>
                <Link to="/owner" className="text-xs text-muted hover:text-plum" data-testid="footer-owner-link">
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-line pt-6">
          <p className="text-xs text-muted" data-testid="footer-copyright">
            © {new Date().getFullYear()} {site.owner} · {site.businessName}
          </p>
        </div>
      </div>
    </footer>
  );
}
